import React, { useEffect, useState } from "react";
import CardBox from "../common/CardBox";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  GetProp,
  Grid,
  Input,
  Row,
  Select,
  Space,
  Table,
  TableProps,
  Tag,
  Typography,
} from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  PlusOutlined,
  HomeOutlined,
  HomeTwoTone,
  ShopOutlined,
  CoffeeOutlined,
  SwapOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { ColumnsType, SorterResult } from "antd/es/table/interface";
import qs from "qs";
import CommonDataTable from "../common/CommonDataTable";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

interface DataType {
  name: {
    first: string;
    last: string;
  };
  gender: string;
  email: string;
  login: {
    uuid: string;
  };
}

interface TableParams {
  pagination?: any;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const { Title, Text } = Typography;
const columns: ColumnsType<DataType> = [
  {
    title: "Booking Number",
    dataIndex: "booking_number",
    sorter: true,
    render: (booking_number) => `${booking_number}`,
    width: "20%",
  },
  {
    title: "Email",
    dataIndex: "email",
    filters: [
      { text: "Male", value: "male" },
      { text: "Female", value: "female" },
    ],
    width: "20%",
  },
  {
    title: "Customer Name",
    dataIndex: "text",
  },
  {
    title: "Created On",
    dataIndex: "text",
  },
  {
    title: "Booking Status",
    dataIndex: "text",
  },
  {
    title: "",
    dataIndex: "Action",
  },
];

const getRandomuserParams = (params: TableParams) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const BookingData = () => {
  const navigate = useNavigate();

  const onRowClick = (event: any) => {
    navigate("/home/booking/edit");
  };
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const setAgeSort = () => {
    setSortedInfo({
      order: "descend",
      columnKey: "age",
    });
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Agt Name",
      dataIndex: "agtName",
      key: "agtName",
    },
    {
      title: "Reference Number	",
      dataIndex: "referenceNumber",
      key: "referenceNumber",
    },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
    },
    {
      title: "Agent Reference Number",
      dataIndex: "agentReferenceNumber",
      key: "agentReferenceNumber",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Adult",
      dataIndex: "adult",
      key: "adult",
    },
    {
      title: "Child",
      dataIndex: "child",
      key: "child",
    },
    {
      title: "Infant",
      dataIndex: "infant",
      key: "infant",
    },
    {
      title: "Booking Date",
      dataIndex: "bookingDate",
      key: "bookingDate",
    },
    {
      title: "Travel Date",
      dataIndex: "travelDate",
      key: "travelDate",
    },
    {
      title: "Cancellation Deadline",
      dataIndex: "cancellationDeadline",
      key: "cancellationDeadline",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "View Details",
      dataIndex: "viewDetails",
      key: "viewDetails",
    },
  ];

  const columnsMobile = [
    {
      dataIndex: "details",
      key: "details",
      render: (_: any, record: any) => {
        // Filter out 'adult', 'child', and 'infant' if their value is "0"
        const filteredData = Object.entries(record).filter(([key, value]) => {
          return !(
            (key === "adult" || key === "child" || key === "infant") &&
            value === "0"
          );
        });
  
        return (
          <div className="mobile-card">
            {filteredData.map(([key, value]) => {
              // Show bookingDate and travelDate in one row
              if (key === "bookingDate") {
                return (
                  <p key={key}>
                    <strong>Booking & Travel Date: </strong>
                    {value} → {record.travelDate}
                  </p>
                );
              }
              if (key === "travelDate") return null; // Hide separate travelDate entry
  
              return (
                <p key={key}>
                  <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                  {React.isValidElement(value) ? value : String(value)}
                </p>
              );
            })}
          </div>
        );
      },
    },
  ];
  

  const data = [
    {
       
      agtName: "John Brown",
      referenceNumber: "AGT-900",
      serviceName: "New York No. 1 Lake Park",
      agentReferenceNumber: "ETMKT980990",
      customerName: "Mr. Gharju",
      adult: "2",
      child: "0",
      infant: "0",
      bookingDate: "29/02/2022",
      travelDate: "30/02/2022",
      cancellationDeadline: "cancellationDeadline",
      status: <Tag color="green">Completed</Tag>,
      viewDetails: "viewDetails",
    },
    {
       
      agtName: "John Brown",
      referenceNumber: "AGT-900",
      serviceName: "New York No. 1 Lake Park",
      agentReferenceNumber: "ETMKT980990",
      customerName: "Mr. Gharju",
      adult: "0",
      child: "0",
      infant: "1",
      bookingDate: "29/02/2022",
      travelDate: "30/02/2022",
      cancellationDeadline: "cancellationDeadline",
      status: <Tag color="red">Rejected</Tag>,
      viewDetails: "viewDetails",
    },
  ];
  const imageOption = [
    {
      value: "all",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#12b8c4",
              verticalAlign: "middle",
            }}
            icon={<HomeOutlined />}
            className="mr-2"
          />
          <span>All</span>
        </div>
      ),
    },
    {
      value: "hotel",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#2c92df",
              verticalAlign: "middle",
            }}
            icon={<ShopOutlined />}
            className="mr-2"
          />
          <span>Hotel</span>
        </div>
      ),
    },
    {
      value: "activities",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#f3b711",
              verticalAlign: "middle",
            }}
            icon={<ShopOutlined />}
            className="mr-2"
          />
          <span>Activities</span>
        </div>
      ),
    },
    {
      value: "meal",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#fc5656",
              verticalAlign: "middle",
            }}
            icon={<CoffeeOutlined />}
            className="mr-2"
          />
          <span>Meal</span>
        </div>
      ),
    },
  ];
  const { useBreakpoint } = Grid; // Correct way to use it
  const screens = useBreakpoint(); // Ensures screens is defined
  return (
    <>
      <Row
        style={{
          flexDirection: screens.lg ? "row" : "column", // lg = row, xs = column
        }}
        gutter={16}
      >
        <Col xs={24} lg={6}>
          <Select
            defaultValue="all"
            options={imageOption}
            className="mb-3 w-100"
          />
        </Col>
        <Col xs={24} lg={18}>
          <Flex
            style={{
              flexWrap: screens.lg ? "nowrap" : "wrap",
              justifyContent: screens.lg ? "flex-end" : "flex-start", // lg = row, xs = column
            }}
          >
            <Button
              shape="round"
              color="primary"
              variant="outlined"
              className={`menu-button ${screens.lg ? "mr-2" : "w-100 mb-2"}`}
              onClick={clearFilters}
            >
              Booking Date
              <SwapOutlined
                style={{
                  color: "#fc5656",
                  verticalAlign: "middle",
                }}
                className="transform90"
              />
            </Button>
            <Button
              shape="round"
              color="primary"
              variant="outlined"
              className={`menu-button ${screens.lg ? "" : "w-100"}`}
              onClick={setAgeSort}
            >
              Cancellation Deadline
              <SwapOutlined
                style={{
                  color: "#fc5656",
                  verticalAlign: "middle",
                }}
                className="transform90"
              />
            </Button>
          </Flex>
        </Col>
      </Row>

      <Table
        bordered
        columns={ screens.lg ? columns : columnsMobile }
        dataSource={data}
        onChange={handleChange}
        className="mt-4 responsiveTable"
      /> 
    </>
  );
};

export const Booking = () => {
  const [searchBookingIsVisible, setSearchBookingIsVisible] = useState(false);
  return (
    <CardBox
      title={
        <Typography.Title
          level={2}
          color="danger"
          className="mb-0 mt-0 primary-color font-weight-700"
        >
          Bookings
          <Text type="danger" className="header-font-title">
            {" "}
            Operations{" "}
          </Text>
        </Typography.Title>
      }
    >
      <div
        className={`drawer-box ${searchBookingIsVisible ? "drawerActive" : ""}`}
      >
        <Card className="topBox transition-all duration-300 ease-in-out">
          <SearchBooking />
        </Card>

        <Button
          className="slideButton"
          onClick={() => setSearchBookingIsVisible(!searchBookingIsVisible)}
        >
          {searchBookingIsVisible ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          )}
        </Button>
      </div>
      <Text type="secondary" className="d-block mb-2">
        Showing 1 to 10 of 800 records
      </Text>
      <BookingData />
    </CardBox>
  );
};

const SearchBooking = () => {
  const [isVisible, setIsVisible] = useState(false);

  const [form] = Form.useForm();
  const [clientReady, setClientReady] = useState<boolean>(false);

  // To disable submit button at the beginning.
  useEffect(() => {
    setClientReady(true);
  }, []);

  const onFinish = (values: any) => {
    console.log("Finish:", values);
  };

  return (
    <>
      <Form
        form={form}
        name="search_booking"
        className="gap-16 align-end"
        layout="inline"
        onFinish={onFinish}
      >
        <Form.Item
          className="filterTextfieldBox"
          label="Search"
          rules={[
            { required: true, message: "Please input your search keywords!" },
          ]}
        >
          <Select
            className="searchInputField"
            defaultValue="Booking Date"
            suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
            options={[
              { value: "Booking Date", label: "Booking Date" },
              { value: "Travel Date", label: "Travel created" },
              { value: "Deadline Date", label: "Deadline created" },
            ]}
          />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Created From"
          rules={[{ required: true, message: "Please select created from!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>

        <Form.Item
          className="filterTextfieldBox"
          label="Created To"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Reference Number"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input className="searchInputField" />
        </Form.Item>

        <Form.Item
          className="filterTextfieldBox"
          label="Status"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Select
            className="searchInputField"
            defaultValue="All"
            suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
            options={[
              { value: "All", label: "All" },
              { value: "booking_created", label: "Booking created" },
            ]}
          />
        </Form.Item>
        <Form.Item shouldUpdate>
          {() => (
            <Button type="primary" size="large" danger className="px-5">
              Search
            </Button>
          )}
        </Form.Item>
      </Form>

      <div>
        <Button
          className="px-0"
          type="link"
          onClick={() => setIsVisible(!isVisible)}
        >
          {isVisible ? "Hide Advance Booking Search" : "Advance Booking Search"}
        </Button>

        {isVisible && (
          <Form
            form={form}
            name="search_booking"
            className="gap-16 align-end"
            layout="inline"
          >
            <Form.Item
              label="Service Type"
              name="serviceType"
              className="filterTextfieldBox"
            >
              <Select
                className="searchInputField"
                defaultValue="All"
                suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
                options={[
                  { value: "All", label: "All" },
                  { value: "Hotel", label: "Hotel" },
                  { value: "Activities", label: "Activities" },
                  { value: "Meal", label: "Meal" },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="Payment Type"
              name="paymentType"
              className="filterTextfieldBox"
            >
              <Select
                className="searchInputField"
                defaultValue="All"
                suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
                options={[
                  { value: "All", label: "All" },
                  { value: "Credit Limit", label: "Credit Limit" },
                  { value: "Activities", label: "Activities" },
                ]}
              />
            </Form.Item>

            <Form.Item
              className="filterTextfieldBox"
              label="Agent & SubAgent"
              name="agentSubAgent"
            >
              <Select
                className="searchInputField"
                defaultValue="All"
                suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
                options={[
                  { value: "All", label: "All" },
                  { value: "SUB_mridul", label: "SUB_mridul" },
                ]}
              />
            </Form.Item>

            <Form.Item
              className="filterTextfieldBox"
              label="Source"
              name="source"
            >
              <Select
                className="searchInputField"
                defaultValue="All"
                suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
                options={[
                  { value: "All", label: "All" },
                  { value: "Website", label: "Website" },
                  { value: "Mobile", label: "Mobile" },
                ]}
              />
            </Form.Item>
            <Form.Item
              className="filterTextfieldBox"
              label="Record Per Page"
              name="recordPerPage"
            >
              <Select
                className="searchInputField"
                defaultValue="All"
                suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
                options={[
                  { value: "50", label: "50" },
                  { value: "100", label: "100" },
                  { value: "500", label: "500" },
                ]}
              />
            </Form.Item>
            <Form.Item className="d-flex align-end mr-0">
              <Button type="primary" size="large" danger className="px-5">
                Advance Search
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    </>
  );
};

export default Booking;
